import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import classNames from "classnames";

import { withStyles } from "@material-ui/core/styles";

import { AppBar, Toolbar, Menu, MenuItem, IconButton, Typography, Button, CircularProgress, LinearProgress, Link, Tooltip, Box } from "@material-ui/core";
import { ArrowBack, Info, Help, MoreVert as MoreIcon, History, Menu as MenuIcon, Chat } from "@material-ui/icons";

import Sidebar from "../../np-dashboard/Sidebar/Sidebar";
import Notifier from "../../np-dashboard/Notifier/Notifier";
import CountdownTimer from "../../np-components/CountdownTimer/CountdownTimer";
import SearchForm from '../../sc-dashboard/Search/SearchForm';
import { getLandingPath } from '../../sc-utilities';
// const drawerWidthOpened = 300;
const drawerWidthClosed = 60;

const styles = (theme) => ({
    root: {
        width: "100%",
    },
    grow: {
        flexGrow: 1,
    },
    sidebarContainer: {
        flex: 1,
    },
    mainContainer: {
        float: "right",
        width: `calc(100% - ${240}px)`,
        transition: theme.transitions.create(["width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    mainContainerBig: {
        width: `calc(100% - ${drawerWidthClosed}px) !important`,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    history: {
        marginLeft: "150px",
        marginRight: "-162px",
        [theme.breakpoints.down("lg")]: {
            marginLeft: "150px",
            marginRight: "-160px",
        },
        [theme.breakpoints.down("md")]: {
            marginRight: "-30px",
            marginLeft: theme.spacing(5),
            width: "auto",
        },
        [theme.breakpoints.down("sm")]: {
            marginRight: 0,
            marginLeft: 0,
            width: "auto",
        },
    },
    hide: {
        display: "none",
    },
    accountLogoNameNormalUser: {
        color: '#E6EDF2'
    },
    accountLogoName: {
        color: '#E6EDF2'
    },
    icon: {
        color: '#E6EDF2'
    },
    appBar: {
        backgroundColor: "#0C5A99",
        color: "#313e48",
    },
    appBarSecurazeUser: {
        backgroundColor: "#140D8A",
        color: "#313e48",
    },
    logo: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block",
            width: "145px",
        },
    },
      help: {
        textDecoration: 'none'
    },   
    sectionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "flex",
        },
    },
    sectionMobile: {
        display: "flex",
        color: '#E6EDF2',
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
    menuInfoItem: {
        backgroundColor: theme.palette.primary.main,
    },
    navLink: {
        textDecoration: "none",
        color: "black",
        opacity: 0.87,
    },
    roles: {
        color: '#E6EDF2',
        textAlign: "right",
    },
});

var id = null;
const listDownloading = (data) => {
    let array = [];
    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            const element = data[key];
            if (element.downloadProgress !== element.maxSizeDownload && element.snackBar) {
                array.push(element);
            }
        }
    }
    return array.map((a) => (
        <div key={`${a.name}-${a.downloadProgress}`}>
            {" "}
            <MenuItem key={`${a.name}-${a.downloadProgress}`}>
                {a.downloadProgress && a.downloadProgress > 0 && a.downloadProgress <= 100 && a.maxSizeDownload && a.currentSizeDownload
                    ? `${a.name} ${a.currentSizeDownload} /  ${a.maxSizeDownload}MB  `
                    : a.downloadProgress && a.downloadProgress > 0 && a.downloadProgress <= 100 ? `${a.name} (${a.downloadProgress}%)` : undefined}
            </MenuItem>
            {a.downloadProgress && a.downloadProgress > 0 && a.downloadProgress < 100 ? (
                <LinearProgress variant="determinate" value={a.downloadProgress} />
            ) : undefined}
        </div>
    ));
};

const Dashboard = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [icon, setIcon] = useState(window.innerWidth < 700);

    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
    const [anchorElDownload, setAnchorElDonwload] = useState(null);

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };
    const handleDownloadClose = () => {
        setAnchorElDonwload(null);
        handleMobileMenuClose();
    };

    useEffect(() => {
        const checkWindowSize = () => {
            setAnchorEl(null);
            setMobileMoreAnchorEl(null);
            setIcon(window.innerWidth < 700)
            if (window.innerWidth < 990) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }

        };
        window.addEventListener("resize", checkWindowSize);
        return () => {
            clearInterval(id);
            window.removeEventListener("resize", checkWindowSize);
        };
    }, []);

    const [sidebarOpen, setSidebarOpen] = useState(!(window.innerWidth < 990));

    const { classes, permissions, children, user, activeCustomer, appBarOptions, countdownTimer, translations, securaze, openHandler, hasLoaded, closeHandler, hubspotId } = props;
    let { sidebarRoutes } = props;
    const isMenuDownloadOpen = Boolean(anchorElDownload);

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleMobileMenuOpen = (event) => {
        setSidebarOpen(false);
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const handleSidebarToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleHoverSidebarToggle = (param) => {
        setSidebarOpen(param);
    };

    const handleChat = useCallback(() => {
        if (!hasLoaded) {
            openHandler();
        } else {
            closeHandler();
        }
    }, [closeHandler, hasLoaded, openHandler])

    // add user identity if chat is opened
    useEffect(() => {
        if (hasLoaded && user) {
            let _hsq = window._hsq = window._hsq || [];
            _hsq.push(["identify", {
                email: user.Email,
                id: user.UserId,
                firstName: user.FirstName,
                lastName: user.LastName,
                phone: user.PhoneNumber,
                securaze_username: user.LoginCredential,
                securaze_customer: activeCustomer?.Name
            }]);
            _hsq.push(['trackPageView']);
            window.HubSpotConversations?.widget?.refresh();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomer?.Name, hasLoaded, securaze, user])

    // Filters the routes from the sidebarRoutes where the user does not have permissions
    const filterSidebarRoutes = (sidebarRoutes, permissions = []) => {
        // SiteWideAdmin can do everything
        if (!(permissions instanceof Array)) {
            return [];
        }

        if (Array.isArray(permissions) && permissions.includes("*")) {
            return sidebarRoutes;
        }

        // TODO check this logic
        // Commented by mmihic, logic is totally wrong
        // if (permissions.length === 0) {
        //     let routes = [sidebarRoutes[0]];
        //     return routes;
        // }

        // Filter out components if the needed permissions are not provided
        sidebarRoutes = sidebarRoutes.filter((sidebarRoute) => {
            let hasPermission = true;
            if (sidebarRoute.permissions) {
                hasPermission = sidebarRoute.permissions.some((permission) => permissions.includes(permission));
            }
            if (sidebarRoute.permissions.length === 0)
                hasPermission = true;
            return hasPermission;
        });

        // Filter out sub-components if the needed permissions are not provided
        sidebarRoutes.forEach((sidebarRoute) => {
            if (sidebarRoute.subComponents) {
                sidebarRoute.subComponents = sidebarRoute.subComponents.filter((subComponent) => {
                    let hasPermission = true;
                    if (subComponent && subComponent.permissions) {
                        // Get operation how to check the permissions
                        const operation = subComponent.operation ? subComponent.operation : "AND";
                        if (operation.toUpperCase() === "OR") {
                            hasPermission = subComponent.permissions.some((permission) => permissions.includes(permission));
                        } else {
                            hasPermission = subComponent.permissions.every((permission) => permissions.includes(permission));
                        }
                    }
                    return hasPermission;
                });
            }
        });
        return sidebarRoutes;
    };

    sidebarRoutes = filterSidebarRoutes(sidebarRoutes, permissions);

    const rolesString = user?.Roles?.map(role => role.Name).join(', ');

    return (
        <div className={classes.root}>
            <div className={classes.sidebarContainer}>
                <Sidebar
                    routes={sidebarRoutes}
                    handleSidebarToggle={handleSidebarToggle}
                    handleHoverSidebarToggle={handleHoverSidebarToggle}
                    open={sidebarOpen}
                    className={classes.sideBar}
                    sidebarStyle={props.sidebarStyle}
                    securaze={securaze}
                />
            </div>
            <div
                className={classNames(props.dashboardStyle ? props.dashboardStyle : classes.mainContainer, {
                    [classes.mainContainerBig]: !sidebarOpen,
                })}
            >
                <AppBar position="sticky" className={securaze ? permissions.includes('*') ? classes.appBar : classes.appBarSecurazeUser : props.appBarStyle? props.appBarStyle: classes.appBar}>
                    <Toolbar>
                        <IconButton className={classes.menuButton} style={{ color: '#E6EDF2' }} color="inherit" aria-label="Open drawer" onClick={handleSidebarToggle}>
                            {sidebarOpen ? (
                                props.sideBarOpenCustomIcon ? (
                                    props.sideBarOpenCustomIcon
                                ) : (
                                    <ArrowBack style={{ color: '#E6EDF2' }} />
                                )
                            ) : props.sideBarCloseCustomIcon ? (
                                props.sideBarCloseCustomIcon
                            ) : (
                                <MenuIcon style={{ color: '#E6EDF2' }} />
                            )}
                        </IconButton>
                        <NavLink to={getLandingPath(permissions)}>
                            <img
                                alt="App Logo"
                                className={classes.logo}
                                src={props.logoPath ? process.env.PUBLIC_URL + props.logoPath : process.env.PUBLIC_URL + securaze ? "/assets/images/logo-light.svg" : ' "/assets/images/app-logo.svg"'}
                            />
                        </NavLink>
                        {!appBarOptions.search || !props.hasLastSearch ? null : (
                            <Tooltip title={translations["get_last_search"] || "Get last search"} className={classes.history}>
                                <IconButton aria-label="Get last search" value={props.id} onClick={() => props.handleNPGlobalSearch(props.hasLastSearch)}>
                                    <History className={classes.icon} ></History>
                                </IconButton>
                            </Tooltip>
                        )}
                        {!appBarOptions.search ? null : (
                            <SearchForm handleNPGlobalSearch={props.handleNPGlobalSearch} sendMessage={props.sendMessage} translations={translations}/>
                        )}
                        {!appBarOptions.search || icon ? null : (
                            <Tooltip title={translations["search_help"] || "Search Help"}>
                                <IconButton aria-haspopup="true" onClick={props.handleNPGlobalSearchInfo} color="inherit">
                                    <Info className={classes.icon} />
                                </IconButton>
                            </Tooltip>

                        )}

                        {!appBarOptions.liveChat || icon ? null : (
                            <Tooltip title={translations["contact_live_chat"] || "Contact/Live Chat"}>
                                <span>
                                    <IconButton onClick={handleChat} disabled={!hubspotId}>
                                        <Chat className={classes.icon} />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        )}

                        {!appBarOptions.help || icon ? null : (
                            <Tooltip title={translations["help_desk"] || "Help desk"}>
                                <IconButton target="_blank" href="https://support.securaze.com/" color="inherit">
                                    <Help className={classes.icon} />
                                </IconButton>
                            </Tooltip>
                        )}
                        <div className={classes.grow} />
                        {countdownTimer ? (
                            <CountdownTimer
                                useDialog={countdownTimer.useDialog}
                                counterValue={countdownTimer.counterValue}
                                remainingSeconds={countdownTimer.remainingSeconds}
                                confirmRemainingSeconds={countdownTimer.confirmRemainingSeconds}
                                onCancel={props.handleLogout}
                                onConfirm={props.handleExtendSession}
                            />
                        ) : null}

                        {props.handleReboot && props.rebootNeeded ? (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", marginLeft: 20, width: 200 }}
                                onClick={props.handleReboot}
                            >
                                {props.rebootLabel}
                            </Button>
                        ) : null}

                        {props.handlePxeRecongifure && props.pxeReconfigureNeeded ? (
                            <Button
                                disabled={props.pxeReconfigureDisabled}
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", marginLeft: 20, width: 200 }}
                                onClick={props.handlePxeRecongifure}
                            >
                                {props.pxeReconfigureDisabled ? <CircularProgress size={24} /> : props.pxeReconfigureLabel}
                            </Button>
                        ) : null}

                        {props.handleNetworkReconfigure && props.networkReconfigureNeeded ? (
                            <Button
                                disabled={props.networkReconfigureDisabled}
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", width: 200, marginLeft: 20 }}
                                onClick={props.handleNetworkReconfigure}
                            >
                                {props.networkReconfigureDisabled ? <CircularProgress size={24} /> : props.networkReconfigureLabel}
                            </Button>
                        ) : null}

                        {props.user ? (
                            <Box container spacing={1} id="app_bar_account_settings" className={classes.sectionDesktop} style={{ flexDirection: "column", alignItems: "end" }}>
                             <Button
                                    style={{ textTransform: "none" }}
                                    onMouseOver={(event) => {
                                        return setAnchorEl(event.currentTarget);
                                    }}
                                    className={securaze ? permissions.includes('*') ? classes.accountLogoName : classes.accountLogoNameNormalUser : classes.accountLogoName}
                                >
                                    {typeof activeCustomer === "object" && activeCustomer !== null && Object.keys(activeCustomer).length > 0
                                        ? `${activeCustomer ? activeCustomer.Name : ""} ${user && user.Username ? ` / ${user.Username}` : ""}`
                                        : `${user && user.Username ? `${user.Username}` : ""}`}
                                </Button>
                                <Typography className={classes.roles}>{`[${rolesString || ''}]`}</Typography>
                            </Box>
                        ) : null}
                        {props.user ? (
                            <IconButton id="app_bar_mobile_account_settings" aria-haspopup="true" onClick={handleMobileMenuOpen} color="inherit" className={classes.sectionMobile}>
                                <MoreIcon />
                            </IconButton>
                        ) : null}
                    </Toolbar>
                </AppBar>

                {/** MOBILE MENU */}
                <Menu
                    anchorEl={mobileMoreAnchorEl}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    open={isMobileMenuOpen}
                    onClose={handleMenuClose}
                >
                    <MenuItem disabled selected className={classes.menuInfoItem}>
                        <Typography>
                            {typeof activeCustomer === "object" && activeCustomer !== null && Object.keys(activeCustomer).length
                                ? `${activeCustomer ? activeCustomer.Name : ""} ${user ? ` / ${user.Username}` : ""}`
                                : `${user ? `${user.Username}` : ""}`}
                        </Typography>
                    </MenuItem>
                    {appBarOptions.myProfile ? (
                        <NavLink className={classes.navLink} to="/myProfile" key={"myProfile"}>
                            <MenuItem id="app_bar_mobile_account_settings_my_profile">{translations ? translations["my_profile"] || "My profile" : "My profile"}</MenuItem>
                        </NavLink>
                    ) : null}
                    {typeof activeCustomer === "object" && activeCustomer !== null ? (
                        <NavLink className={classes.navLink} to="/changeActiveCustomer" key={"changeActiveCustomer"}>
                            <MenuItem id="app_bar_mobile_account_settings_change_active_customer">{translations ? translations["change_active_customer"] || "Change active customer" : "Change active customer"}</MenuItem>
                        </NavLink>
                    ) : null}
                    {icon ? (
                        <div>
                            {appBarOptions.search ? <MenuItem onClick={props.handleNPGlobalSearchInfo}>{translations["search_help"] || "Search Help"}</MenuItem> : null}
                            {appBarOptions.liveChat ? <MenuItem onClick={handleChat} disabled={!hubspotId}>{translations["contact_live_chat"] || "Contact/Live Chat"}</MenuItem> : null}
                            {appBarOptions.help ? <Link href="https://twentoo.ladesk.com/" target="_blank" underline={'none'} color="inherit" >
                                <MenuItem color="inherit">{translations["help_desk"] || "Help desk"}</MenuItem>
                            </Link>
                                : null}
                        </div>
                    ) : null}

                    <MenuItem id="app_bar_mobile_account_settings_logout" onClick={props.handleLogout}>{translations ? translations["logout"] || "Logout" : "Logout"}</MenuItem>
                </Menu>
                {/** MENU */}
                <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    open={isMenuOpen}
                    onClose={handleMenuClose}
                    MenuListProps={{
                        onMouseLeave: handleMenuClose,
                    }}
                >
                    {appBarOptions.myProfile ? (
                        <NavLink className={classes.navLink} to="/myProfile" key={"myProfile"}>
                            <MenuItem id="app_bar_account_settings_my_profile">{translations ? translations["my_profile"] || "My profile" : "My profile"}</MenuItem>
                        </NavLink>
                    ) : null}
                    {!appBarOptions.disableActiveCustomer && typeof activeCustomer === "object" && activeCustomer !== null ? (
                        <NavLink className={classes.navLink} to="/changeActiveCustomer" key={"changeActiveCustomer"}>
                            <MenuItem id="app_bar_account_settings_change_active_customer">{translations ? translations["change_active_customer"] || "Change active customer" : "Change active customer"}</MenuItem>
                        </NavLink>
                    ) : null}

                    {props.supportSessionActive ? (
                        <div>
                            <MenuItem onClick={props.endSupportSession}>End support session</MenuItem>
                            <MenuItem id="app_bar_account_settings_logout" onClick={props.handleLogout}>{translations ? translations["logout"] || "Logout" : "Logout"}</MenuItem>
                        </div>
                    ) :
                        (
                            <MenuItem id="app_bar_account_settings_logout" onClick={props.handleLogout}>{translations ? translations["logout"] || "Logout" : "Logout"}</MenuItem>
                        )}
                </Menu>


                {/** MENU DOWNLOAD */}
                {!appBarOptions.download ? null : (
                    <Menu
                        anchorEl={anchorElDownload}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        open={isMenuDownloadOpen}
                        onClose={handleDownloadClose}
                        MenuListProps={{
                            onMouseLeave: handleDownloadClose,
                        }}
                    >
                        {listDownloading(props.downloadData ? props.downloadData.currentDownloadData : {})}
                    </Menu>
                )}
                {/* Render children components if there is any*/}
                {children}
            </div>
            <Notifier />
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        permissions: state?.core?.login?.permissions || [],
        user: state && state.core && state.core.login ? state.core.login.user : null,
        activeCustomer: state && state.core && state.core.login ? state.core.login.activeCustomer : null,
        downloadData: state.download && state.download.download ? state.download.download : {},
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(Dashboard));
